import { p as proxyCustomElement, H, h, d as Host } from './p-bfa0dc67.js';
import { a as applySpacingProps } from './p-15440395.js';

const biButtonGroupCss = ".sr-only{position:absolute;height:1px;width:1px;padding:0;margin:-1px;overflow:hidden;border:0;left:-9999px;text-indent:-5000px;clip:rect(1px, 1px, 1px, 1px);}*,*:before,*:after{box-sizing:border-box}html,body,div,span,object,iframe,figure,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,code,em,img,small,strike,strong,sub,sup,tt,b,u,i,ol,ul,li,fieldset,form,label,table,caption,tbody,tfoot,thead,tr,th,td,main,canvas,embed,footer,header,nav,section,button,video{margin:0;padding:0;border:0;font-size:100%;font:inherit;vertical-align:baseline;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;text-size-adjust:none}footer,header,nav,section,main{display:block}body{line-height:1.5}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:before,blockquote:after,q:before,q:after{content:\"\";content:none}table{border-collapse:collapse;border-spacing:0}input{-webkit-appearance:none;appearance:none;border-radius:0}:host(:focus){outline:none !important;border:none !important}:host{display:flex;width:100%}.button-group{display:flex;flex-wrap:wrap;border:unset !important;width:100%}.button-group.horizontal{flex-direction:row}.button-group.vertical{flex-direction:column}.button-group.horizontal-center{justify-content:center}.button-group.horizontal-left{justify-content:flex-start}.button-group.horizontal-right{justify-content:flex-end}.button-group.vertical-center{align-items:center}.button-group.vertical-left{align-items:flex-start}.button-group.vertical-right{align-items:flex-end}.button-group.x-small{gap:8px}.button-group.small{gap:12px}.button-group.medium{gap:16px}.button-group.large{gap:24px}.button-group.x-large{gap:32px}.button-group.xx-large{gap:40px}";
const BiButtonGroupStyle0 = biButtonGroupCss;

const BiButtonGroup$1 = /*@__PURE__*/ proxyCustomElement(class BiButtonGroup extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        /**
         * Alignment of the button group. Can be 'left', 'center', or 'right'.
         * @default 'left'
         */
        this.alignment = 'left';
        /**
         * Direction of the button group. Can be 'horizontal' or 'vertical'.
         * @default 'horizontal'
         */
        this.direction = 'horizontal';
        /**
         * Spacing size between buttons in the group.
         * Will be applied to the gap property on the button group.
         * @default 'small'
         */
        this.spacing = 'small';
    }
    componentWillLoad() {
        applySpacingProps(this.el, this.top, this.bottom, this.left, this.right);
    }
    render() {
        const _alignment = `${this.direction}-${this.alignment}`;
        const className = `button-group ${_alignment} ${this.direction} ${this.spacing}`;
        return (h(Host, { key: 'de41c7f8e31f4625949800c090c33e571502319d' }, h("div", { key: 'd680145b0f403a613817aeea0ff8f61c65f6de3b', class: className }, h("slot", { key: '030b349188e967e8492d1f59e94031cb2348d601' }))));
    }
    get el() { return this; }
    static get style() { return BiButtonGroupStyle0; }
}, [1, "bi-button-group", {
        "alignment": [1],
        "direction": [1],
        "spacing": [1],
        "top": [1],
        "bottom": [1],
        "left": [1],
        "right": [1]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bi-button-group"];
    components.forEach(tagName => { switch (tagName) {
        case "bi-button-group":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BiButtonGroup$1);
            }
            break;
    } });
}

const BiButtonGroup = BiButtonGroup$1;
const defineCustomElement = defineCustomElement$1;

export { BiButtonGroup, defineCustomElement };
